<template>
  <v-card max-width="344" outlined>
    <v-card-title>{{title}}</v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="filterText"
            label="Filter text"
            dense
            outlined
            clearable
            @input="updateFilter()"
          ></v-text-field>
        </v-col>
        <v-col class="mt-0 pt-0">
          <v-list dense>
            <v-virtual-scroll
              :bench="benched"
              :items="filteredItem"
              height="200"
              item-height="64"
            >
              <template v-slot:default="{ item }">
                <v-list-item :key="itemKeyFunc(item)" @click="onItemClick(item)">
                  <v-list-item-icon>
                    <v-icon>mdi-plus</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="itemTextFunc(item)"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-virtual-scroll>
          </v-list>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import { mdiClose } from "@mdi/js";

export default {
  name: "List",
  async created() {
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ""
    },
    allowFiltering: {
      type: Boolean,
      default: false
    },
    itemText: {
      type: String,
      default: "name"
    },
    itemKey: {
      type: String,
      default: "uuid"
    },
    clickable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      icons: {
        mdiClose,
      },
      benched: 0,
      filterText: "",
      message: "",
      filterFunc: (x) => x,
    };
  },
  computed: {
    filteredItem() {
      return this.items.filter(this.filterFunc);
    },
  },
  methods: {
    itemTextFunc(item) {
      return item[this.itemText];
    },
    itemKeyFunc(item) {
      return item[this.itemKey];
    },
    updateFilter() {
      if (this.filterText) {
        this.filterFunc = (c) =>
          this.itemTextFunc(c)
            .toLowerCase()
            .trim()
            .search(this.filterText.trim().toLowerCase()) >= 0;
      } else {
        this.filterFunc = (x) => x;
      }
    },
    onItemClick(item) {
      if (!this.clickable) {
        return;
      }
      this.$emit("onClick", item);
    }
  },
};
</script>